export default {
	red: {
		"rgb[]": [0.8666666666666667, 0.19215686274509805, 0.1843137254901961],
		"RGB[]": [221, 49, 47],
		"css-hex": "#dd312f",
		"css-rgb": "rgb(221, 49, 47)",
		"css-rgba": "rgba(221, 49, 47, 1)",
		rgb: "0.87, 0.19, 0.18",
		RGB: "221, 49, 47",
		latex: "\\definecolor{red}{rgb}{0.87, 0.19, 0.18}",
		asy: "pen red = rgb(0.87, 0.19, 0.18);",
	},
	darkred: {
		"rgb[]": [0.5176470588235295, 0.11372549019607843, 0.10980392156862745],
		"RGB[]": [132, 29, 28],
		"css-hex": "#841d1c",
		"css-rgb": "rgb(132, 29, 28)",
		"css-rgba": "rgba(132, 29, 28, 1)",
		rgb: "0.52, 0.11, 0.11",
		RGB: "132, 29, 28",
		latex: "\\definecolor{darkred}{rgb}{0.52, 0.11, 0.11}",
		asy: "pen darkred = rgb(0.52, 0.11, 0.11);",
	},
	lightred: {
		"rgb[]": [0.9058823529411765, 0.43137254901960786, 0.42745098039215684],
		"RGB[]": [231, 110, 109],
		"css-hex": "#e76e6d",
		"css-rgb": "rgb(231, 110, 109)",
		"css-rgba": "rgba(231, 110, 109, 1)",
		rgb: "0.91, 0.43, 0.43",
		RGB: "231, 110, 109",
		latex: "\\definecolor{lightred}{rgb}{0.91, 0.43, 0.43}",
		asy: "pen lightred = rgb(0.91, 0.43, 0.43);",
	},
	extralightred: {
		"rgb[]": [0.9725490196078431, 0.8352941176470589, 0.8352941176470589],
		"RGB[]": [248, 213, 213],
		"css-hex": "#f8d5d5",
		"css-rgb": "rgb(248, 213, 213)",
		"css-rgba": "rgba(248, 213, 213, 1)",
		rgb: "0.97, 0.84, 0.84",
		RGB: "248, 213, 213",
		latex: "\\definecolor{extralightred}{rgb}{0.97, 0.84, 0.84}",
		asy: "pen extralightred = rgb(0.97, 0.84, 0.84);",
	},
	teal: {
		"rgb[]": [0.3215686274509804, 0.5686274509803921, 0.6039215686274509],
		"RGB[]": [82, 145, 154],
		"css-hex": "#52919a",
		"css-rgb": "rgb(82, 145, 154)",
		"css-rgba": "rgba(82, 145, 154, 1)",
		rgb: "0.32, 0.57, 0.60",
		RGB: "82, 145, 154",
		latex: "\\definecolor{teal}{rgb}{0.32, 0.57, 0.60}",
		asy: "pen teal = rgb(0.32, 0.57, 0.60);",
	},
	darkteal: {
		"rgb[]": [0.19215686274509805, 0.3411764705882353, 0.3607843137254902],
		"RGB[]": [49, 87, 92],
		"css-hex": "#31575c",
		"css-rgb": "rgb(49, 87, 92)",
		"css-rgba": "rgba(49, 87, 92, 1)",
		rgb: "0.19, 0.34, 0.36",
		RGB: "49, 87, 92",
		latex: "\\definecolor{darkteal}{rgb}{0.19, 0.34, 0.36}",
		asy: "pen darkteal = rgb(0.19, 0.34, 0.36);",
	},
	lightteal: {
		"rgb[]": [0.5215686274509804, 0.6980392156862745, 0.7215686274509804],
		"RGB[]": [133, 178, 184],
		"css-hex": "#85b2b8",
		"css-rgb": "rgb(133, 178, 184)",
		"css-rgba": "rgba(133, 178, 184, 1)",
		rgb: "0.52, 0.70, 0.72",
		RGB: "133, 178, 184",
		latex: "\\definecolor{lightteal}{rgb}{0.52, 0.70, 0.72}",
		asy: "pen lightteal = rgb(0.52, 0.70, 0.72);",
	},
	extralightteal: {
		"rgb[]": [0.8627450980392157, 0.9137254901960784, 0.9176470588235294],
		"RGB[]": [220, 233, 234],
		"css-hex": "#dce9ea",
		"css-rgb": "rgb(220, 233, 234)",
		"css-rgba": "rgba(220, 233, 234, 1)",
		rgb: "0.86, 0.91, 0.92",
		RGB: "220, 233, 234",
		latex: "\\definecolor{extralightteal}{rgb}{0.86, 0.91, 0.92}",
		asy: "pen extralightteal = rgb(0.86, 0.91, 0.92);",
	},
	green: {
		"rgb[]": [0.30980392156862746, 0.6588235294117647, 0],
		"RGB[]": [79, 168, 0],
		"css-hex": "#4fa800",
		"css-rgb": "rgb(79, 168, 0)",
		"css-rgba": "rgba(79, 168, 0, 1)",
		rgb: "0.31, 0.66, 0.00",
		RGB: "79, 168, 0",
		latex: "\\definecolor{green}{rgb}{0.31, 0.66, 0.00}",
		asy: "pen green = rgb(0.31, 0.66, 0.00);",
	},
	darkgreen: {
		"rgb[]": [0.1843137254901961, 0.39215686274509803, 0],
		"RGB[]": [47, 100, 0],
		"css-hex": "#2f6400",
		"css-rgb": "rgb(47, 100, 0)",
		"css-rgba": "rgba(47, 100, 0, 1)",
		rgb: "0.18, 0.39, 0.00",
		RGB: "47, 100, 0",
		latex: "\\definecolor{darkgreen}{rgb}{0.18, 0.39, 0.00}",
		asy: "pen darkgreen = rgb(0.18, 0.39, 0.00);",
	},
	lightgreen: {
		"rgb[]": [0.5137254901960784, 0.7607843137254902, 0.2980392156862745],
		"RGB[]": [131, 194, 76],
		"css-hex": "#83c24c",
		"css-rgb": "rgb(131, 194, 76)",
		"css-rgba": "rgba(131, 194, 76, 1)",
		rgb: "0.51, 0.76, 0.30",
		RGB: "131, 194, 76",
		latex: "\\definecolor{lightgreen}{rgb}{0.51, 0.76, 0.30}",
		asy: "pen lightgreen = rgb(0.51, 0.76, 0.30);",
	},
	extralightgreen: {
		"rgb[]": [0.8588235294117647, 0.9294117647058824, 0.8],
		"RGB[]": [219, 237, 204],
		"css-hex": "#dbedcc",
		"css-rgb": "rgb(219, 237, 204)",
		"css-rgba": "rgba(219, 237, 204, 1)",
		rgb: "0.86, 0.93, 0.80",
		RGB: "219, 237, 204",
		latex: "\\definecolor{extralightgreen}{rgb}{0.86, 0.93, 0.80}",
		asy: "pen extralightgreen = rgb(0.86, 0.93, 0.80);",
	},
	orange: {
		"rgb[]": [0.8784313725490196, 0.403921568627451, 0],
		"RGB[]": [224, 103, 0],
		"css-hex": "#e06700",
		"css-rgb": "rgb(224, 103, 0)",
		"css-rgba": "rgba(224, 103, 0, 1)",
		rgb: "0.88, 0.40, 0.00",
		RGB: "224, 103, 0",
		latex: "\\definecolor{orange}{rgb}{0.88, 0.40, 0.00}",
		asy: "pen orange = rgb(0.88, 0.40, 0.00);",
	},
	darkorange: {
		"rgb[]": [0.5254901960784314, 0.23921568627450981, 0],
		"RGB[]": [134, 61, 0],
		"css-hex": "#863d00",
		"css-rgb": "rgb(134, 61, 0)",
		"css-rgba": "rgba(134, 61, 0, 1)",
		rgb: "0.53, 0.24, 0.00",
		RGB: "134, 61, 0",
		latex: "\\definecolor{darkorange}{rgb}{0.53, 0.24, 0.00}",
		asy: "pen darkorange = rgb(0.53, 0.24, 0.00);",
	},
	lightorange: {
		"rgb[]": [0.9137254901960784, 0.5803921568627451, 0.2980392156862745],
		"RGB[]": [233, 148, 76],
		"css-hex": "#e9944c",
		"css-rgb": "rgb(233, 148, 76)",
		"css-rgba": "rgba(233, 148, 76, 1)",
		rgb: "0.91, 0.58, 0.30",
		RGB: "233, 148, 76",
		latex: "\\definecolor{lightorange}{rgb}{0.91, 0.58, 0.30}",
		asy: "pen lightorange = rgb(0.91, 0.58, 0.30);",
	},
	extralightorange: {
		"rgb[]": [0.9725490196078431, 0.8784313725490196, 0.8],
		"RGB[]": [248, 224, 204],
		"css-hex": "#f8e0cc",
		"css-rgb": "rgb(248, 224, 204)",
		"css-rgba": "rgba(248, 224, 204, 1)",
		rgb: "0.97, 0.88, 0.80",
		RGB: "248, 224, 204",
		latex: "\\definecolor{extralightorange}{rgb}{0.97, 0.88, 0.80}",
		asy: "pen extralightorange = rgb(0.97, 0.88, 0.80);",
	},
	blue: {
		"rgb[]": [0.3411764705882353, 0.20784313725490197, 1],
		"RGB[]": [87, 53, 255],
		"css-hex": "#5735ff",
		"css-rgb": "rgb(87, 53, 255)",
		"css-rgba": "rgba(87, 53, 255, 1)",
		rgb: "0.34, 0.21, 1.00",
		RGB: "87, 53, 255",
		latex: "\\definecolor{blue}{rgb}{0.34, 0.21, 1.00}",
		asy: "pen blue = rgb(0.34, 0.21, 1.00);",
	},
	darkblue: {
		"rgb[]": [0.20392156862745098, 0.12156862745098039, 0.6],
		"RGB[]": [52, 31, 153],
		"css-hex": "#341f99",
		"css-rgb": "rgb(52, 31, 153)",
		"css-rgba": "rgba(52, 31, 153, 1)",
		rgb: "0.20, 0.12, 0.60",
		RGB: "52, 31, 153",
		latex: "\\definecolor{darkblue}{rgb}{0.20, 0.12, 0.60}",
		asy: "pen darkblue = rgb(0.20, 0.12, 0.60);",
	},
	lightblue: {
		"rgb[]": [0.5372549019607843, 0.44313725490196076, 1],
		"RGB[]": [137, 113, 255],
		"css-hex": "#8971ff",
		"css-rgb": "rgb(137, 113, 255)",
		"css-rgba": "rgba(137, 113, 255, 1)",
		rgb: "0.54, 0.44, 1.00",
		RGB: "137, 113, 255",
		latex: "\\definecolor{lightblue}{rgb}{0.54, 0.44, 1.00}",
		asy: "pen lightblue = rgb(0.54, 0.44, 1.00);",
	},
	extralightblue: {
		"rgb[]": [0.8666666666666667, 0.8392156862745098, 1],
		"RGB[]": [221, 214, 255],
		"css-hex": "#ddd6ff",
		"css-rgb": "rgb(221, 214, 255)",
		"css-rgba": "rgba(221, 214, 255, 1)",
		rgb: "0.87, 0.84, 1.00",
		RGB: "221, 214, 255",
		latex: "\\definecolor{extralightblue}{rgb}{0.87, 0.84, 1.00}",
		asy: "pen extralightblue = rgb(0.87, 0.84, 1.00);",
	},
	purple: {
		"rgb[]": [0.6862745098039216, 0.24313725490196078, 1],
		"RGB[]": [175, 62, 255],
		"css-hex": "#af3eff",
		"css-rgb": "rgb(175, 62, 255)",
		"css-rgba": "rgba(175, 62, 255, 1)",
		rgb: "0.69, 0.24, 1.00",
		RGB: "175, 62, 255",
		latex: "\\definecolor{purple}{rgb}{0.69, 0.24, 1.00}",
		asy: "pen purple = rgb(0.69, 0.24, 1.00);",
	},
	darkpurple: {
		"rgb[]": [0.4117647058823529, 0.1450980392156863, 0.6],
		"RGB[]": [105, 37, 153],
		"css-hex": "#692599",
		"css-rgb": "rgb(105, 37, 153)",
		"css-rgba": "rgba(105, 37, 153, 1)",
		rgb: "0.41, 0.15, 0.60",
		RGB: "105, 37, 153",
		latex: "\\definecolor{darkpurple}{rgb}{0.41, 0.15, 0.60}",
		asy: "pen darkpurple = rgb(0.41, 0.15, 0.60);",
	},
	lightpurple: {
		"rgb[]": [0.7803921568627451, 0.4666666666666667, 1],
		"RGB[]": [199, 119, 255],
		"css-hex": "#c777ff",
		"css-rgb": "rgb(199, 119, 255)",
		"css-rgba": "rgba(199, 119, 255, 1)",
		rgb: "0.78, 0.47, 1.00",
		RGB: "199, 119, 255",
		latex: "\\definecolor{lightpurple}{rgb}{0.78, 0.47, 1.00}",
		asy: "pen lightpurple = rgb(0.78, 0.47, 1.00);",
	},
	extralightpurple: {
		"rgb[]": [0.9372549019607843, 0.8470588235294118, 1],
		"RGB[]": [239, 216, 255],
		"css-hex": "#efd8ff",
		"css-rgb": "rgb(239, 216, 255)",
		"css-rgba": "rgba(239, 216, 255, 1)",
		rgb: "0.94, 0.85, 1.00",
		RGB: "239, 216, 255",
		latex: "\\definecolor{extralightpurple}{rgb}{0.94, 0.85, 1.00}",
		asy: "pen extralightpurple = rgb(0.94, 0.85, 1.00);",
	},
	pink: {
		"rgb[]": [0.9098039215686274, 0.24705882352941178, 1],
		"RGB[]": [232, 63, 255],
		"css-hex": "#e83fff",
		"css-rgb": "rgb(232, 63, 255)",
		"css-rgba": "rgba(232, 63, 255, 1)",
		rgb: "0.91, 0.25, 1.00",
		RGB: "232, 63, 255",
		latex: "\\definecolor{pink}{rgb}{0.91, 0.25, 1.00}",
		asy: "pen pink = rgb(0.91, 0.25, 1.00);",
	},
	darkpink: {
		"rgb[]": [0.5450980392156862, 0.1450980392156863, 0.6],
		"RGB[]": [139, 37, 153],
		"css-hex": "#8b2599",
		"css-rgb": "rgb(139, 37, 153)",
		"css-rgba": "rgba(139, 37, 153, 1)",
		rgb: "0.55, 0.15, 0.60",
		RGB: "139, 37, 153",
		latex: "\\definecolor{darkpink}{rgb}{0.55, 0.15, 0.60}",
		asy: "pen darkpink = rgb(0.55, 0.15, 0.60);",
	},
	lightpink: {
		"rgb[]": [0.9333333333333333, 0.47058823529411764, 1],
		"RGB[]": [238, 120, 255],
		"css-hex": "#ee78ff",
		"css-rgb": "rgb(238, 120, 255)",
		"css-rgba": "rgba(238, 120, 255, 1)",
		rgb: "0.93, 0.47, 1.00",
		RGB: "238, 120, 255",
		latex: "\\definecolor{lightpink}{rgb}{0.93, 0.47, 1.00}",
		asy: "pen lightpink = rgb(0.93, 0.47, 1.00);",
	},
	extralightpink: {
		"rgb[]": [0.9803921568627451, 0.8470588235294118, 1],
		"RGB[]": [250, 216, 255],
		"css-hex": "#fad8ff",
		"css-rgb": "rgb(250, 216, 255)",
		"css-rgba": "rgba(250, 216, 255, 1)",
		rgb: "0.98, 0.85, 1.00",
		RGB: "250, 216, 255",
		latex: "\\definecolor{extralightpink}{rgb}{0.98, 0.85, 1.00}",
		asy: "pen extralightpink = rgb(0.98, 0.85, 1.00);",
	},
	magenta: {
		"rgb[]": [0.7490196078431373, 0, 0.5137254901960784],
		"RGB[]": [191, 0, 131],
		"css-hex": "#bf0083",
		"css-rgb": "rgb(191, 0, 131)",
		"css-rgba": "rgba(191, 0, 131, 1)",
		rgb: "0.75, 0.00, 0.51",
		RGB: "191, 0, 131",
		latex: "\\definecolor{magenta}{rgb}{0.75, 0.00, 0.51}",
		asy: "pen magenta = rgb(0.75, 0.00, 0.51);",
	},
	darkmagenta: {
		"rgb[]": [0.4470588235294118, 0, 0.3058823529411765],
		"RGB[]": [114, 0, 78],
		"css-hex": "#72004e",
		"css-rgb": "rgb(114, 0, 78)",
		"css-rgba": "rgba(114, 0, 78, 1)",
		rgb: "0.45, 0.00, 0.31",
		RGB: "114, 0, 78",
		latex: "\\definecolor{darkmagenta}{rgb}{0.45, 0.00, 0.31}",
		asy: "pen darkmagenta = rgb(0.45, 0.00, 0.31);",
	},
	lightmagenta: {
		"rgb[]": [0.8235294117647058, 0.2980392156862745, 0.6588235294117647],
		"RGB[]": [210, 76, 168],
		"css-hex": "#d24ca8",
		"css-rgb": "rgb(210, 76, 168)",
		"css-rgba": "rgba(210, 76, 168, 1)",
		rgb: "0.82, 0.30, 0.66",
		RGB: "210, 76, 168",
		latex: "\\definecolor{lightmagenta}{rgb}{0.82, 0.30, 0.66}",
		asy: "pen lightmagenta = rgb(0.82, 0.30, 0.66);",
	},
	extralightmagenta: {
		"rgb[]": [0.9490196078431372, 0.8, 0.9019607843137255],
		"RGB[]": [242, 204, 230],
		"css-hex": "#f2cce6",
		"css-rgb": "rgb(242, 204, 230)",
		"css-rgba": "rgba(242, 204, 230, 1)",
		rgb: "0.95, 0.80, 0.90",
		RGB: "242, 204, 230",
		latex: "\\definecolor{extralightmagenta}{rgb}{0.95, 0.80, 0.90}",
		asy: "pen extralightmagenta = rgb(0.95, 0.80, 0.90);",
	},
	gray: {
		"rgb[]": [0.6, 0.6, 0.6],
		"RGB[]": [153, 153, 153],
		"css-hex": "#999999",
		"css-rgb": "rgb(153, 153, 153)",
		"css-rgba": "rgba(153, 153, 153, 1)",
		rgb: "0.60, 0.60, 0.60",
		RGB: "153, 153, 153",
		latex: "\\definecolor{gray}{rgb}{0.60, 0.60, 0.60}",
		asy: "pen gray = rgb(0.60, 0.60, 0.60);",
	},
	darkgray: {
		"rgb[]": [0.3568627450980392, 0.3568627450980392, 0.3568627450980392],
		"RGB[]": [91, 91, 91],
		"css-hex": "#5b5b5b",
		"css-rgb": "rgb(91, 91, 91)",
		"css-rgba": "rgba(91, 91, 91, 1)",
		rgb: "0.36, 0.36, 0.36",
		RGB: "91, 91, 91",
		latex: "\\definecolor{darkgray}{rgb}{0.36, 0.36, 0.36}",
		asy: "pen darkgray = rgb(0.36, 0.36, 0.36);",
	},
	lightgray: {
		"rgb[]": [0.7176470588235294, 0.7176470588235294, 0.7176470588235294],
		"RGB[]": [183, 183, 183],
		"css-hex": "#b7b7b7",
		"css-rgb": "rgb(183, 183, 183)",
		"css-rgba": "rgba(183, 183, 183, 1)",
		rgb: "0.72, 0.72, 0.72",
		RGB: "183, 183, 183",
		latex: "\\definecolor{lightgray}{rgb}{0.72, 0.72, 0.72}",
		asy: "pen lightgray = rgb(0.72, 0.72, 0.72);",
	},
	extralightgray: {
		"rgb[]": [0.9176470588235294, 0.9176470588235294, 0.9176470588235294],
		"RGB[]": [234, 234, 234],
		"css-hex": "#eaeaea",
		"css-rgb": "rgb(234, 234, 234)",
		"css-rgba": "rgba(234, 234, 234, 1)",
		rgb: "0.92, 0.92, 0.92",
		RGB: "234, 234, 234",
		latex: "\\definecolor{extralightgray}{rgb}{0.92, 0.92, 0.92}",
		asy: "pen extralightgray = rgb(0.92, 0.92, 0.92);",
	},
	grey: {
		"rgb[]": [0.6, 0.6, 0.6],
		"RGB[]": [153, 153, 153],
		"css-hex": "#999999",
		"css-rgb": "rgb(153, 153, 153)",
		"css-rgba": "rgba(153, 153, 153, 1)",
		rgb: "0.60, 0.60, 0.60",
		RGB: "153, 153, 153",
		latex: "\\definecolor{grey}{rgb}{0.60, 0.60, 0.60}",
		asy: "pen grey = rgb(0.60, 0.60, 0.60);",
	},
	darkgrey: {
		"rgb[]": [0.3568627450980392, 0.3568627450980392, 0.3568627450980392],
		"RGB[]": [91, 91, 91],
		"css-hex": "#5b5b5b",
		"css-rgb": "rgb(91, 91, 91)",
		"css-rgba": "rgba(91, 91, 91, 1)",
		rgb: "0.36, 0.36, 0.36",
		RGB: "91, 91, 91",
		latex: "\\definecolor{darkgrey}{rgb}{0.36, 0.36, 0.36}",
		asy: "pen darkgrey = rgb(0.36, 0.36, 0.36);",
	},
	lightgrey: {
		"rgb[]": [0.7176470588235294, 0.7176470588235294, 0.7176470588235294],
		"RGB[]": [183, 183, 183],
		"css-hex": "#b7b7b7",
		"css-rgb": "rgb(183, 183, 183)",
		"css-rgba": "rgba(183, 183, 183, 1)",
		rgb: "0.72, 0.72, 0.72",
		RGB: "183, 183, 183",
		latex: "\\definecolor{lightgrey}{rgb}{0.72, 0.72, 0.72}",
		asy: "pen lightgrey = rgb(0.72, 0.72, 0.72);",
	},
	extralightgrey: {
		"rgb[]": [0.9176470588235294, 0.9176470588235294, 0.9176470588235294],
		"RGB[]": [234, 234, 234],
		"css-hex": "#eaeaea",
		"css-rgb": "rgb(234, 234, 234)",
		"css-rgba": "rgba(234, 234, 234, 1)",
		rgb: "0.92, 0.92, 0.92",
		RGB: "234, 234, 234",
		latex: "\\definecolor{extralightgrey}{rgb}{0.92, 0.92, 0.92}",
		asy: "pen extralightgrey = rgb(0.92, 0.92, 0.92);",
	},
};
